export const KAI = {
    name: "WKAI Token",
    symbol: "WKAI",
    address: "0xAF984E23EAA3E7967F3C5E007fbe397D8566D23d",
    chainId: 0,
    decimals: 18,
    logoURI:"https://kardiachain-explorer.s3-ap-southeast-1.amazonaws.com/explorer.kardiachain.io/logo/0aca55ee239466bc4bbfd01ac9451bcadbabd66e.png",
};

export const kardiaTokens = {
    WKAI: KAI,
    WNATIVE: KAI,
    SEN: {
        name: "SEN Token",
        symbol: "SEN",
        address: "0xb697231730C004110A86f51BfF4B8DD085c0CB28",
        chainId: 0,
        decimals: 18,
        logoURI:"https://kardiachain-explorer.s3-ap-southeast-1.amazonaws.com/explorer.kardiachain.io/logo/b697231730C004110A86f51BfF4B8DD085c0CB28.png",
    },
    BECO: {
        name: "BECO Token",
        symbol: "BECO",
        address: "0x2Eddba8b949048861d2272068A94792275A51658",
        chainId: 0,
        decimals: 18,
        logoURI:"https://kardiachain-explorer.s3-ap-southeast-1.amazonaws.com/explorer.kardiachain.io/logo/2Eddba8b949048861d2272068A94792275A51658.png",
    },
    KABA: {
        name: "Kripto Galaxy Battle",
        symbol: "KABA",
        address: "0x5C5058de24497359Ff64F7318f5C2b5581FF6B05",
        chainId: 0,
        decimals: 18,
        logoURI:"https://kardiachain-explorer.s3-ap-southeast-1.amazonaws.com/explorer.kardiachain.io/logo/0x5C5058de24497359Ff64F7318f5C2b5581FF6B05.png",
    },
    KPHI: {
        name: "Kephi Gallery Token",
        symbol: "KPHI",
        address: "0x6CD689DefCA80f9F2CBED9D0C6f3B2Cf4abc4598",
        chainId: 0,
        decimals: 18,
        logoURI:"https://kardiachain-explorer.s3-ap-southeast-1.amazonaws.com/explorer.kardiachain.io/logo/0x6CD689DefCA80f9F2CBED9D0C6f3B2Cf4abc4598.png",
    },
    USDT: {
        name: "Tether USD",
        symbol: "USDT",
        address: "0x551A5dcAC57C66aA010940c2dcFf5DA9c53aa53b",
        chainId: 0,
        decimals: 6,
        logoURI:"https://kardiachain-explorer.s3-ap-southeast-1.amazonaws.com/explorer.kardiachain.io/logo/0x551A5dcAC57C66aA010940c2dcFf5DA9c53aa53b.png",
    },
    BNB: {
        name: "BNB Token",
        symbol: "BNB",
        address: "0xd7D045BFBa6Ea93b480F409DB3dd1729337C1d13",
        chainId: 0,
        decimals: 18,
        logoURI:"https://kardiachain-explorer.s3-ap-southeast-1.amazonaws.com/explorer.kardiachain.io/logo/d7D045BFBa6Ea93b480F409DB3dd1729337C1d13.png",
    },
    BUSD: {
        name: "BUSD Token",
        symbol: "BUSD",
        address: "0x3444273AFdf9E00Fd0491C8a97738acA3ebB2A93",
        chainId: 0,
        decimals: 18,
        logoURI:"https://kardiachain-explorer.s3-ap-southeast-1.amazonaws.com/explorer.kardiachain.io/logo/3444273AFdf9E00Fd0491C8a97738acA3ebB2A93.png",
    },
    ETH: {
        name: "Ether Token",
        symbol: "ETH",
        address: "0x1540020a94aA8bc189aA97639Da213a4ca49d9a7",
        chainId: 0,
        decimals: 18,
        logoURI:"https://kardiachain-explorer.s3-ap-southeast-1.amazonaws.com/explorer.kardiachain.io/logo/1540020a94aA8bc189aA97639Da213a4ca49d9a7.png",
    },
    KDX: {
        name: "KAIDEX Token",
        symbol: "KDX",
        address: "0xE9caC5d99375d02Fb506bE890011B2F57fC614E1",
        chainId: 0,
        decimals: 18,
        logoURI:"https://raw.githubusercontent.com/kardiachain/token-assets/master/tokens/0xE9caC5d99375d02Fb506bE890011B2F57fC614E1/logo.png",
    },
    USDC: {
        name: "USD Coin",
        symbol: "USDC",
        address: "0x765277EebeCA2e31912C9946eAe1021199B39C61",
        chainId: 0,
        decimals: 6,
        logoURI:"https://raw.githubusercontent.com/kardiachain/token-assets/master/tokens/0x765277EebeCA2e31912C9946eAe1021199B39C61/logo.png",
    }
}